import { Person as PersonIcon, LocationOn as AddressIcon } from '@mui/icons-material';

interface RecipientDetailsProps {
  recipient: string | undefined;
  address: string;
}

const RecipientDetails = ({ recipient, address }: RecipientDetailsProps) => {
  return (
    <div className='flex flex-col flex-1 pl-16 md:pl-0'>
      <div className='flex items-center gap-1.5 text-base text-gray-700 font-black'>
        <PersonIcon sx={{ fontSize: 18, color: '#bbb' }} />
        {recipient || 'S/D'}
      </div>
      <div className='flex items-center gap-1.5 text-sm text-gray-400 font-bold mt-0.5'>
        <AddressIcon sx={{ fontSize: 16 }} />
        {address}
      </div>
    </div>
  );
};

export default RecipientDetails;
